export const getSelectedGroupPoints = ({ items, selectedGroupId }) => {
  const results = []
  const matchingGroup = items.find((group) => group?.familyGroupId === selectedGroupId)

  if (matchingGroup) {
    matchingGroup?.persons.forEach((person) => {
      const hasAlreadyBeenAddedToResults = !!results.find(
        (addedPerson) => addedPerson.memberCisId === person.memberCisId
      )
      if (!hasAlreadyBeenAddedToResults) {
        results.push(person)
      }
    })
  }
  return results.sort((sortItem1, sortItem2) => {
    if (sortItem2?.points !== sortItem1?.points) return sortItem2.points - sortItem1.points
    // else sort alphabetically
    if (sortItem2?.userProfileName.toLowerCase() < sortItem1?.userProfileName.toLowerCase()) return 1
    if (sortItem2?.userProfileName.toLowerCase() > sortItem1?.userProfileName.toLowerCase()) return -1
    return 0
  })
}
export const _ = ''
